export default "assets/images/map-bd0fa1ab.jpg";